export default "__VITE_ASSET__8166e987__"